import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useSignup from "../Hooks/useSignup";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";

const SignUpPage = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [userName,setUserName] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({});
  const { signup, loading } = useSignup();
  const navigate = useNavigate();

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[0-9]{11}$/;
    return phoneRegex.test(number);
  };
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    console.log("name-->",name,"userName-->",userName, "email--->",email,"phoneNumber--->",phoneNumber, "password--->",password)
    e.preventDefault();
    const emailValidate = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    const emailResult = emailValidate.test(email);
    if (name.length < 1) {
      setErrors((pre) => ({
        ...pre,
        nameError: "Your password must be Three characters",
      }));
    }
    if (!emailResult === true) {
      setErrors((pre) => ({
        ...pre,
        emailError: "Please enter a valid email address to continue",
      }));
    }
    if (password.length < 1) {
      setErrors((pre) => ({
        ...pre,
        passwordError: "Your password must be four characters",
      }));
    }

    if(userName.length<1){
      setErrors((pre) => ({
        ...pre,
        userNameError: " Please Enter a valid userName ",
      }));
    }

    // Clear previous errors

    // Validate phone number
    if (!validatePhoneNumber(phoneNumber)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phoneNumber: "Phone number must be a valid 10-digit number",
      }));
      return;
    }
    // setErrors({});

    if (!captchaToken) {
      toast.error("Please complete the captcha verification.");
      return;
    }

    const response = await signup(name,userName,email,password,phoneNumber);
    if (response?.success) {
      navigate("/login");
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="flex justify-center flex-col column items-center">
      <div className="d-flex w-full bg-gray-50 p-3 flex justify-center ">
        <h2 className="text-xl font-bold text-center">Register</h2>
      </div>
      <div className="w-full max-w-md p-6 my-16 rounded-lg">
        <form onSubmit={handleSubmit}>
          {/* Name Field */}
          <div className="relative mb-6">
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
            />
            <label
              htmlFor="name"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
                ${name ? "top-2 scale-75" : "top-5 scale-100"}
                peer-focus:top-2 peer-focus:scale-75`}
            >
              Name <span className="text-red-500">*</span>
            </label>
            {errors.nameError && (
              <p className="text-red-500 text-sm mt-1">{errors.nameError}</p>
            )}
          </div>


          <div className="relative mb-6">
            <input
              type="text"
              id="userName"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
            />
            <label
              htmlFor="userName"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
                ${userName ? "top-2 scale-75" : "top-5 scale-100"}
                peer-focus:top-2 peer-focus:scale-75`}
            >
              UserName <span className="text-red-500">*</span>
            </label>
            {errors.userNameError && (
              <p className="text-red-500 text-sm mt-1">{errors.userNameError}</p>
            )}
          </div>

          {/* Email Field */}
          <div className="relative mb-6">
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
            />
            <label
              htmlFor="email"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
                ${email ? "top-2 scale-75" : "top-5 scale-100"}
                peer-focus:top-2 peer-focus:scale-75`}
            >
              Email <span className="text-gray-500"></span>
            </label>
            {/* {errors.emailError && (
              <p className="text-red-500 text-sm mt-1">{errors.emailError}</p>
            )} */}
          </div>

         
          {/* Phone Number Field */}
          <div className="relative mb-6">
  <input
    type="text"
    id="phone_number"
    placeholder="0300 0000000"
    value={phoneNumber}
    onChange={(e) => setPhoneNumber(e.target.value)}
    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer placeholder:pl-[110px]"
  />
  <label
    htmlFor="phone_number"
    className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
      ${phoneNumber ? "top-2 scale-75" : "top-5 scale-100"}
      peer-focus:top-2 peer-focus:scale-75`}
  >
    Phone Number <span className="text-red-500">*</span>
  </label>
  {errors.phoneNumber && (
    <p className="text-red-500 text-sm mt-1">{errors.phoneNumber}</p>
  )}
</div>


          {/* Password Field */}
          <div className="relative mb-6">
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 peer"
            />
            <label
              htmlFor="password"
              className={`absolute left-4 text-sm duration-300 transform -translate-y-1/2 origin-[0]
                ${password ? "top-2 scale-75" : "top-5 scale-100"}
                peer-focus:top-2 peer-focus:scale-75`}
            >
              Password <span className="text-red-500">*</span>
            </label>
            {errors.passwordError && (
              <p className="text-red-500 text-sm mt-1">
                {errors.passwordError}
              </p>
            )}
          </div>
          {process.env.REACT_APP_RECAPTCHA_ENABLER === "true" ? (
            <div className="mb-4">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
              />
            </div>
          ) : null}

          <button
            type="submit"
            className={`w-full py-2 text-white bg-black rounded-xl hover:bg-gray-900 transition ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? "Creating Account..." : "Register"}
          </button>
          <div className="mt-4 text-left">
            <a href="/login" className="text-sm underline hover:text-gray-200">
              Already have an account? Login here
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUpPage;
